// Routes
import './routes';

// Auth handler
import authHandler from './utils/auth-handler';
Vue.use(authHandler);

// Workspace handler
import workspaceHandler from './utils/workspace-handler';
Vue.use(workspaceHandler);

// Interface handler
import userInterfaceHandler from './utils/user-interface-handler';
Vue.use(userInterfaceHandler);

// Dark mode handler
import darkModeHandler from './utils/dark-mode-handler';
Vue.use(darkModeHandler);

// Components
import './components/form/CmsLoginForm';
import './components/form/CmsPasswordRecoveryForm';
import './components/form/CmsPasswordResetForm';
import './components/form/controls/CmsMediaControl.js';
import './components/form/controls/CmsLinkControl.js';
import './components/form/controls/CmsRouteMappingMatrix.js';
import './components/form/controls/CmsSlugControl.js';

// share
import './components/share/CmsShareMenuItem.js';
import './components/share/CmsShareModal.js';

// share
import './components/preview/CmsPublicationPreviewItem';

// media
import './components/media/CmsMediaCard.js';
import './components/media/CmsMediaRelationResolver.js';
import './components/media/CmsMediaInspector.js';
import './components/media/CmsMediaRelationDataTable.js';
import './components/media/CmsFocalPointEditor.js';

// published
import './components/published/CmsPublishedToggle.js';

// QR code 2FA
import './components/form/widget/QRCode2FA.js';

// account
import './components/account/CmsAccountMenu';
import './components/account/CmsProfile';
import './components/account/CmsSetHomepage';
import './components/account/CmsDarkModeControl';
import './components/account/CmsWelcome';

// Inbox
import './components/inbox/CmsInboxDetail';

// layout
import './components/layout/CmsActiveWorkspace';
import './components/layout/CmsActiveWorkspaceLogo';
import './components/dashboard/widgets/CmsDashboardDebugStatus';
import './components/dashboard/widgets/CmsDashboardDisplayErrorsStatus';
import './components/dashboard/widgets/CmsDashboardEmailDebugStatus';
import './components/dashboard/widgets/CmsDashboardDeadLinksCheck';
import './components/dashboard/widgets/CmsDashboardHeadingStructureCheck';
import './components/dashboard/widgets/CmsDashboardImageAltTagsCheck';
import './components/dashboard/widgets/CmsDashboardFaviconCheck';
import './components/dashboard/widgets/CmsDashboardHttpToHttpsRedirectCheck';
import './components/dashboard/widgets/CmsDashboardSslCertificateExpiryCheck';
import './components/dashboard/widgets/CmsDashboardQueueWorkers';
import './components/dashboard/widgets/CmsDashboardSiteFilesCheck';
import './components/dashboard/widgets/CmsDashboardWwwRedirectCheck';
import './components/dashboard/widgets/CmsDashboardIssuesSummary';
import './components/dashboard/widgets/CmsDashboardPageStatusCheck';
import './components/dashboard/widgets/CmsDashboardProfile';
import './components/dashboard/widgets/CmsDashboardSeoMetaDescriptions';
import './components/dashboard/widgets/CmsDashboardSeoSocialMetaTags';
import './components/dashboard/widgets/CmsDashboardShortcut';
import './components/dashboard/widgets/CmsDashboardSeoUniqueTitleTags';
import './components/dashboard/widgets/CmsDashboardSpineVersion';
import './components/dashboard/widgets/CmsDashboardUpcomingPagesOnline';
import './components/dashboard/widgets/CmsDashboardUpcomingPagesOffline';
import './components/dashboard/widgets/CmsDashboardUpcomingPublicationsOnline';
import './components/dashboard/widgets/CmsDashboardUpcomingPublicationsOffline';
import './components/dashboard/widgets/CmsDashboardConceptPages';
import './components/dashboard/widgets/CmsDashboardChecksAccordion';
import './components/dashboard/widgets/CmsDashboardTitle';
import './components/layout/CmsSettingsMenu';

// Seo
import './components/seo/CmsSeoPreview';

// Page
import './components/pages/CmsForm';
import './components/pages/CmsGrid';
import './components/pages/CmsImport';
import './components/pages/CmsList';
import './components/pages/CmsPageNotFound';
import './components/pages/CmsDashboard';
import './components/dashboard/editor/CmsDashboardLayoutEditor';
import './components/dashboard/editor/CmsDashboardEditorPage';
import './components/dashboard/editor/CmsDashboardEditorSideBar';
import './components/dashboard/editor/CmsDashboardEditorTopBar';
import './components/dashboard/editor/CmsDashboardWidgetType';
import './components/dashboard/editor/CmsDashboardWidgetTypeGroup';
import './components/dashboard/editor/CmsDashboardWidgetTypeList';
import './components/dashboard/editor/CmsDashboardSettingsForm';
import './components/pages/CmsPasswordResetExpired';
import './components/pages/CmsHistory';

// Grid
import './components/grid/CmsAutoSaveBadge.js';

// Redactor plugins
import './utils/redactor-plugins/link-to';
